export default __webpack_public_path__ + "c7642252af784dd5d4bd22be8c91ee06.png";